module.exports = __webpack_public_path__ + "static/media/coduo-logo-black.89e17318.png";